import { FC } from 'react';
import { Page401 } from './page-401';

export const PageAccessDenied: FC = () => (
    <Page401 title="No Access" message="You are not authorized to access the tool." />
);
